const tagtest = /{(.+)}/g;
// eslint-disable-next-line
const unicodetest = /[^\u0000-\u00ff]/;

export const makeMessage = (item, message) => {
    for (var k in item) {
        if (k[0] != '$') continue;
        message = message.split("{" + k + "}").join(item[k]);
    }
    const res = tagtest.exec(message);
    if (res) {
        message = message.replaceAll(/{.*?}/g, "");
    }
    return message;
}
/**      
1 SMS - līdz 160 (70) simboli
2 SMS - līdz 306 (134) simboli
3 SMS - līdz 459 (201) simboli
4 SMS - līdz 612 (268) simboli
5 SMS - līdz 765 (335) simboli
6 SMS - līdz 918 (402) simboli
7 SMS - līdz 1071 (469) simboli
*/
export const calculateParts = (len, isUnicode) => {
    if (isUnicode) {
        // unicode
        if (len > 469) return 0;
        else if (len > 402) return 7;
        else if (len > 335) return 6;
        else if (len > 268) return 5;
        else if (len > 201) return 4;
        else if (len > 134) return 3;
        else if (len > 70) return 2;
        else return 1;
    } else {
        //ascii
        if (len > 1071) return 0;
        else if (len > 918) return 7;
        else if (len > 765) return 6;
        else if (len > 612) return 5;
        else if (len > 459) return 4;
        else if (len > 306) return 3;
        else if (len > 160) return 2;
        else return 1;
    }

}

export const calculatePrice = (count, tarif) => { return count * tarif; }

export const addTarifData = (task, tarif, make) => {
    if (task.status == 1) {
        task.price = 0;
        task.msgcount = 0;
    }
    task.recipients.items.forEach(e => {
        try {
            if (make) e.text = makeMessage(e, task.message);
            if (e.text == undefined) e.text = makeMessage(e, task.message);
            e.unicode = unicodetest.test(e.text);
            e.len = e.text.length;
            //if (e.unicode) e.len = e.len * 2;
            if (task.status == 1) {
                e.count = calculateParts(e.len, e.unicode);
                task.msgcount += e.count;
                e.price = calculatePrice(e.count, tarif);
                task.price += e.price;
            }
        } catch (error) {
            return;
        }
    });
    if (task.status == 1) task.price = Math.ceil(task.price / 100);


}
